import { render, staticRenderFns } from "./shopuserlist.vue?vue&type=template&id=65efb71e&scoped=true"
import script from "./shopuserlist.vue?vue&type=script&lang=js"
export * from "./shopuserlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65efb71e",
  null
  
)

export default component.exports